import DATA from "../config/const";

const {
  header,
  headerDesc,
  action,
  feedbackTitle,
  feedbacks,
  expect,
  use,
  version,
  extra,
} = DATA;
import action1 from "@/assets/action1.svg";
import action2 from "@/assets/action2.svg";
import action3 from "@/assets/action3.svg";
import action4 from "@/assets/action4.svg";
import arrow1 from "@/assets/arrow1.svg";
import arrow2 from "@/assets/arrow2.svg";
import arrow3 from "@/assets/arrow3.svg";
import arrow4 from "@/assets/arrow4.svg";

const actionImages = {
  action1,
  action2,
  action3,
  action4,
};

const arrowImages = {
  arrow1,
  arrow2,
  arrow3,
  arrow4,
};

export default {
  data() {
    return {
      header,
      headerDesc,
      feedbackTitle,
      feedbacks,
      expect,
      use,
      version,
      extra,
      actionData: [],
    };
  },
  mounted() {
    this.actionData = action.map((item, index) => {
      return {
        actionImage: actionImages[`action${index + 1}`],
        arrowImage: arrowImages[`arrow${index + 1}`],
        ...item,
      };
    });
  },
};
